import { monicoreListener } from '@fiverr-private/obs';

/**
 * Register Obs listener for bigQuery
 * @param MonicoreListenerConfig config
 */
export const listener = monicoreListener;
